import { forwardRef } from "react";
import { ChevronDown } from "lucide-react";

import { Button } from "@/components/_atoms/button";

export const SelectTriggerButton = forwardRef<HTMLButtonElement, { value: string; disabled?: boolean }>(
  ({ value, disabled, ...props }, ref) => (
    <Button
      ref={ref}
      variant="outline"
      size="sm"
      className="h-8 w-full justify-between text-sm font-normal"
      disabled={disabled}
      {...props}
    >
      <span className="truncate">{value}</span>
      <ChevronDown className="ml-1 h-3 w-3 shrink-0 opacity-50" />
    </Button>
  ),
);
SelectTriggerButton.displayName = "SelectTriggerButton";
